import { useEffect, useState } from 'react';
import { classNames } from 'shared/lib/classNames/classNames';
import { speakerData } from 'widgets/PlotSteps/model/api/speakerData';
import cls from './SpeechBox.module.scss';

interface SpeechBoxProps {
    className?: string
    message?: string
    name?: string
    buttonsCount?: number
};

export const SpeechBox = (props: SpeechBoxProps) => {
    const {
        className,
        message,
        name,
        buttonsCount,
    } = props;
    const [text, setText] = useState('');

    // useEffect(() => {
    //     setText('');

    //     const interval = setInterval(setText, 25, (text) => {
    //         if (text.length + 1 > message.length) {
    //             clearInterval(interval);
    //         }

    //         return message.slice(0, text.length + 1);
    //     });

    //     return () => clearInterval(interval);
    // }, [message]);

    return (
        <div className={classNames(cls.SpeechBox, {}, [className])}>
            <div className={classNames(cls.container, { [cls.pb150]: buttonsCount === 2 })}>
                <div className={cls.name}>
                    {name}
                </div>
                <div className={cls.message}>
                    {/* {text} */}
                    {message}
                </div>
            </div>
        </div>
    );
};
